export namespace BoardSize {
  export namespace Plugin {
    export const Name = 'board-size';
  }
}
